<template>
  <div>
    <generic-container
      :title="$t('general information')"
      icon="circle info"
      :searchable="false"
      :show_plus="false"
      :configurable="false"
      :header_buttons="header_buttons"
      style="margin-top:15px"
    >
      <div class="ui items">
        <div class="item">
          <div class="ui tiny circular image">
            <img src="/images/icons/compose.png" />
          </div>
          <div class="content">
            <a class="header">{{ project.name }}</a>
            <div class="description">{{ project.description }}</div>
            <div class="meta">
              <span>
                {{ $t("since") }}
                {{
                  project.create_date
                    | formatDate(enterprise_setup.simple_date_format)
                }}
              </span>
            </div>
            <div class="extra"></div>
          </div>
        </div>
      </div>
    </generic-container>
    <div class="ui segment container">
      <div class="ui one item pointing menu" ref="tabs">
        <a class="item active" data-tab="layers">
          <i class="layer group icon"></i>
          {{ $t("layers") }}
        </a>
      </div>
      <layer-management data-tab="layers" :project="project" v-on:save="save" />
    </div>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
        :project="project"
      ></component>
    </template>
  </div>
</template>

<script>
import {
  local_api,
  error_toast,
  clone,
  success_toast,
  enterprise_setup,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import LayerManagement from "@/modules/pixel_art/project/LayerManagement";

// import "../../../modules/ngine_composer/business_object/BusinessObjectManagement"
import ProjectModal from "../ProjectModal";
import filters from "@/filters";

export default {
  name: "PixelArtProjectIndex",
  filters: filters,
  components: {
    GenericContainer,
    LayerManagement,
  },
  data() {
    return {
      project: { setup: {} },
      popup_modals: [],
      modal_origin: "",
      header_buttons: [
        {
          color: "brown",
          icon: "cloud download",
          click: this.export_project,
        },
        {
          color: "orange",
          icon: "edit",
          click: this.edit_project,
        },
        {
          color: "blue",
          icon: "save",
          click: this.save,
        },
        {
          color: "red",
          icon: "trash",
          click: this.remove_project,
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    remove_project() {
      let vm = this;
      this.$alertify.confirm(
        this.$t("are you sure to remove project?"),
        function() {
          local_api(vm, "post", "/pixel_art/project/do-remove", {
            u: vm.project.uuid,
          })
            .then(() => {
              vm.$router.push({
                name: "PixelArtIndex",
              });
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    edit_project() {
      this.popup_modals.push(ProjectModal);
    },
    save() {
      let vm = this;

      let _req = clone(vm.project.setup);

      local_api(vm, "post", "/pixel_art/project/do-save", {
        i: vm.project.uuid,
        s: JSON.stringify(_req),
      })
        .then(() => {
          success_toast(vm.$t("updated successfully"));
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    succedded(project) {
      if (this.modal_origin != "deploy") {
        this.project.name = project.name;
        this.project.description = project.description;
      } else this.modal_origin = "";
    },
    destroy() {
      this.popup_modals = [];
    },
    export_project() {
      console.log("pending to to");
      // let to_export = clone(this.project);
      // delete to_export.project_id;
      // delete to_export.enterprise_id;
      // delete to_export.create_date;
      // delete to_export.create_user_id;
      // delete to_export.ngn_project_snapshots;
      // delete to_export.human_tasks_compose;
      // var blob = new Blob([JSON.stringify(to_export, null)], {
      //   type: "application/json;charset=utf-8",
      // });
      // var url = URL.createObjectURL(blob);
      // var elem = document.createElement("a");
      // elem.href = url;
      // elem.download = `export_${this.project.name}_${Date.now()}.ngine`;
      // document.body.appendChild(elem);
      // elem.click();
      // document.body.removeChild(elem);
    },
  },
  mounted() {
    let vm = this;
    let uuid = this.$route.query.i;

    let defaultSetup = {
      layers: [],
    };

    if (uuid) {
      local_api(vm, "post", "/pixel_art/project/do-get", { u: uuid })
        .then((project) => {
          if (project.setup) {
            project.setup = JSON.parse(project.setup);
            if (!project.setup.layers) project.setup = defaultSetup;
          } else project.setup = defaultSetup;
          vm.project = project;
        })
        .catch((err) => {
          error_toast(err);
        });
    } else {
      error_toast(this.$t("no project"));
    }

    window
      .jQuery(vm.$refs.tabs)
      .find(".item")
      .tab();
  },
  watch: {},
};
</script>
